import React, { useState, useEffect } from "react";
import "./Domain.css";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";

const Domain = () => {
  const [domains, setDomains] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false); // State for loading
  const [showOriginalDomains, setShowOriginalDomains] = useState(true); // State to manage visibility

  useEffect(() => {
    setLoading(true); // Start loading
    fetch("https://api.spadserver.com/api/domain")
      .then((response) => response.json())
      .then((data) => setDomains(data))
      .finally(() => setLoading(false)); // Stop loading
  }, []);

  const handleSearch = (event) => {
    event.preventDefault(); // Prevent default form submission
    setLoading(true); // Start loading
    setShowOriginalDomains(false); // Hide original domains when search is initiated
    fetch(`https://api.spadserver.com/api/domain-search?domain=${searchTerm}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.other) {
          setSearchResults(data.other);
        }
      })
      .finally(() => setLoading(false)); // Stop loading
  };

  const stripHtmlTags = (str) => {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
  };

  return (
    <div className="container mx-auto px-4 md:px-8 text-white m-8 relative">
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-70 z-50">
          <LoadingSpinner />
        </div>
      )}
      <h1 className="text-2xl font-bold mb-10">ثبت دامنه</h1>
      <div className="flex justify-center mb-20">
        ثبت دامنه و خرید انواع پسوند های دامنه از اسپاد سرور همین امروز دامنه
        خود را با قیمت مناسب ثبت کنید
      </div>

      {/* Search Bar */}
      <div className="flex justify-center mb-8">
  <form onSubmit={handleSearch} className="flex">
    <input
      type="text"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder="جستجوی دامنه..."
      className="p-2 border-gray-300 text-black focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-r-md"
    />
    <button
      type="submit"
      className="ml-0 p-2 bg-blue-500 text-white rounded-l-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      جستجو
    </button>
  </form>
</div>


      {/* Domain Search Results */}
      {!showOriginalDomains && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 mb-8">
          {searchResults.map((domain, index) => (
            <div key={index} className="relative p-4 border rounded-lg bg-gray-800 border-gray-700 hover:border-gray-500 hover:bg-gray-700 transition duration-300 ease-in-out">
              <div className="domain-content text-center">
                <h2 className="domain-text-search text-xl font-semibold mb-2 text-white hover:text-green-400">
                  دامنه {domain.tls}
                </h2>
                <div className="annually-search text-white mb-2">(سالانه)</div>
                <div className="bottom-content flex justify-between items-center">                  <p className={`mt-2 font-bold text-sm ${domain.isAvailable ? 'text-green-400' : 'text-red-400'}`}>
                    {domain.isAvailable ? "در دسترس" : "غیر قابل دسترس"}
                  </p>
                  {domain.isAvailable && (
                    <a
                      href={`https://crm.spadserver.com/cart.php?a=add&domain=${searchTerm}.${domain.tls}`}
                      className="purchase-button bg-black mt-4 block text-center py-2 px-4 rounded hover:bg-gray-800"
                    >
                      خرید دامنه
                    </a>
                  )}
                </div>
              </div>
              <div className="domain-description mt-2 text-gray-300">
                <p>Availability: {domain.isAvailable ? "در دسترس" : "غیر قابل دسترس"}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Existing Domain Data */}
      {showOriginalDomains && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
          {domains.map((domain, index) => (
            <div key={index} className="relative p-4 border rounded-lg bg-gray-800 border-gray-700 hover:border-gray-500 hover:bg-gray-700 transition duration-300 ease-in-out">
              <div className="domain-content text-center">
                <div className="image-title-container">
                  <img
                    className="w-10 mx-auto"
                    src="images/domain-registration.png"
                    alt=""
                  /> 
                </div>
                <h2 className="domain-text text-xl font-semibold mb-2 text-white hover:text-green-400">
                  دامنه {domain.title}
                </h2>
                <div className="annually-search text-white mb-2">(سالانه)</div>
                <div className="bottom-content flex justify-between items-center">
                  <p className="mt-2 font-bold text-[12px]">
                    {domain.year} {domain.currency.suffix}
                  </p>
                  <a
                    href={domain.slug}
                    className="purchase-button text-black bg-black mt-2 block text-center py-2 px-4 rounded hover:bg-gray-800"
                  >
                    خرید دامنه
                  </a>
                </div>
              </div>
              <div className="domain-description mt-2 text-gray-300">
                <p>{stripHtmlTags(domain.description)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Domain;
